<div class="heading--strip">
    <div class="comp-address">
        <span class="title">{{pharmacyInfo?.name | uppercase}}</span><br/>
        <span class="address">{{pharmacyInfo?.address}}</span>
    </div>
    <div class="comp-phone">
        <span class="PhNum"><span class="material-symbols-outlined">phone_in_talk</span>
        <a id="phoneLink" (click)="handlePhoneClick($event)">{{PatientPhoneNo}}</a>
        <div id="tooltip" class="tooltip-clip">Phone number copied!</div>
    </span>
        
    </div>
    <div class="phrma-logo"> 
        <img alt="Pharmacy" class="phrmaLogo-bg" src="/assets/images/Pharmacy.png"/>
    </div>
</div>